// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mx-64 {\n  margin-left: 64px !important;\n  margin-right: 64px !important;\n}\n.nowrap {\n  flex-wrap: nowrap !important;\n}\n@media (max-width: 768px) {\ndiv[style*=\"backgroundImage\"] {\n    height: auto; /* Permite que a altura seja ajustada automaticamente */\n}\n}\n", ""]);
// Exports
module.exports = exports;
